/*
 * @see https://namespaces.chainagnostic.org/stellar/README
 */

// if the value neeeds to be change make sure you will update mapCaipNamespaceToLegacyNetworkName as well
export const CAIP_NAMESPACE = 'stellar';
export const CAIP_STELLAR_CHAIN_ID = 'mainnet';

export const HORIZON_URL = 'https://horizon.stellar.org';
